import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  ErrorTooltipModule,
  TooltipPositionModule
} from '@com-delta-idp/mnx-ui-kit';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
import { SessionTimeOutModule } from '../../common/session-time-out/session-time-out.module';
import { FlyoutLoggedinUserModule } from '../../flyout/flyout-loggedin-user/flyout-loggedin-user.module';
import { FlyoutLoggedinModule } from '../../flyout/flyout-loggedin/flyout-loggedin.module';
import { FlyoutModalModule } from '../../flyout/flyout-modal/flyout-modal.module';
import { CommonService } from '../../services/common.service';

// This Module's Components
import { LoginComponent } from './login.component';
@NgModule({
  imports: [
    CommonModule,
    DataLayerModule,
    FlyoutLoggedinModule,
    FlyoutLoggedinUserModule,
    FlyoutModalModule,
    SessionTimeOutModule,
    FormsModule,
    ModalModule.forRoot(),
    RouterModule,
    ErrorTooltipModule,
    TooltipPositionModule
  ],
  declarations: [LoginComponent],
  exports: [LoginComponent],
  providers: [BsModalRef, BsModalService, CommonService]
})
export class LoginModule {}
